import axios from 'axios';

export const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return !payload.exp || payload.exp * 1000 <= Date.now();
  } catch {
    return true;
  }
};

export const forceLogout = (reason) => {
  const path = window.location.pathname + window.location.search;
  if (!path.startsWith('/login')) {
    sessionStorage.setItem('post_login_redirect', path);
  }
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  const q = reason ? `?${reason}=1` : '?expired=1';
  window.location.href = `/login${q}`;
};

let guardInstalled = false;

export const initSessionGuard = () => {
  if (guardInstalled) return;
  guardInstalled = true;

  const token = localStorage.getItem('token');
  if (token && isTokenExpired(token)) {
    if (window.location.pathname !== '/login') {
      forceLogout();
      return;
    }
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      const url = error?.config?.url || '';
      const hadAuthHeader = !!error?.config?.headers?.Authorization;
      const detail = error?.response?.data?.detail;
      const code = detail && typeof detail === 'object' ? detail.code : null;

      // Banned or archived by admin — force logout with a specific reason so the
      // login page can show an appropriate message
      if (status === 403 && (code === 'USER_BANNED' || code === 'USER_ARCHIVED')) {
        forceLogout(code === 'USER_BANNED' ? 'banned' : 'deleted');
        return Promise.reject(error);
      }

      if (status === 401 && !url.includes('/api/auth/') && (hadAuthHeader || localStorage.getItem('token'))) {
        forceLogout();
      }
      return Promise.reject(error);
    }
  );
};
